module.exports = __webpack_public_path__ + "img/太白赊月.d4183a5a.jpg";